function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Transport } from "../transport.js";
import { randomString } from "../util.js";
import { encodePayload, decodePayload } from "engine.io-parser";
export var Polling = /*#__PURE__*/ function(Transport) {
    "use strict";
    _inherits(Polling, Transport);
    function Polling() {
        _class_call_check(this, Polling);
        var _this;
        _this = _call_super(this, Polling, arguments);
        _this._polling = false;
        return _this;
    }
    _create_class(Polling, [
        {
            key: "name",
            get: function get() {
                return "polling";
            }
        },
        {
            /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ key: "doOpen",
            value: function doOpen() {
                this._poll();
            }
        },
        {
            /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ key: "pause",
            value: function pause(onPause) {
                var _this = this;
                this.readyState = "pausing";
                var pause = function() {
                    _this.readyState = "paused";
                    onPause();
                };
                if (this._polling || !this.writable) {
                    var total = 0;
                    if (this._polling) {
                        total++;
                        this.once("pollComplete", function() {
                            --total || pause();
                        });
                    }
                    if (!this.writable) {
                        total++;
                        this.once("drain", function() {
                            --total || pause();
                        });
                    }
                } else {
                    pause();
                }
            }
        },
        {
            /**
     * Starts polling cycle.
     *
     * @private
     */ key: "_poll",
            value: function _poll() {
                this._polling = true;
                this.doPoll();
                this.emitReserved("poll");
            }
        },
        {
            /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ key: "onData",
            value: function onData(data) {
                var _this = this;
                var callback = function(packet) {
                    // if its the first message we consider the transport open
                    if ("opening" === _this.readyState && packet.type === "open") {
                        _this.onOpen();
                    }
                    // if its a close packet, we close the ongoing requests
                    if ("close" === packet.type) {
                        _this.onClose({
                            description: "transport closed by the server"
                        });
                        return false;
                    }
                    // otherwise bypass onData and handle the message
                    _this.onPacket(packet);
                };
                // decode payload
                decodePayload(data, this.socket.binaryType).forEach(callback);
                // if an event did not trigger closing
                if ("closed" !== this.readyState) {
                    // if we got data we're not polling
                    this._polling = false;
                    this.emitReserved("pollComplete");
                    if ("open" === this.readyState) {
                        this._poll();
                    } else {}
                }
            }
        },
        {
            /**
     * For polling, send a close packet.
     *
     * @protected
     */ key: "doClose",
            value: function doClose() {
                var _this = this;
                var close = function() {
                    _this.write([
                        {
                            type: "close"
                        }
                    ]);
                };
                if ("open" === this.readyState) {
                    close();
                } else {
                    // in case we're trying to close while
                    // handshaking is in progress (GH-164)
                    this.once("open", close);
                }
            }
        },
        {
            /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ key: "write",
            value: function write(packets) {
                var _this = this;
                this.writable = false;
                encodePayload(packets, function(data) {
                    _this.doWrite(data, function() {
                        _this.writable = true;
                        _this.emitReserved("drain");
                    });
                });
            }
        },
        {
            /**
     * Generates uri for connection.
     *
     * @private
     */ key: "uri",
            value: function uri() {
                var schema = this.opts.secure ? "https" : "http";
                var query = this.query || {};
                // cache busting is forced
                if (false !== this.opts.timestampRequests) {
                    query[this.opts.timestampParam] = randomString();
                }
                if (!this.supportsBinary && !query.sid) {
                    query.b64 = 1;
                }
                return this.createUri(schema, query);
            }
        }
    ]);
    return Polling;
}(Transport);
